export const getPoliza = (state) => {
   return state.polizaDenunciar;
};
